import { Component, OnInit, Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ApiService } from 'src/app/_services/api.service';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {

  LanguageId: number = 0
  CountryCode: string = ""; 
  customStyle: string;
  TermsAndConditionsText:SafeHtml;
  constructor(
    private dialogRef: MatDialogRef<TermsAndConditionsComponent>,
    private apiService: ApiService,
    private sanitizer: DomSanitizer
  ) {
    this.customStyle = "<style>h2,h3,h4 {color: var(--app-brand-cyan) !important;}</style>"
  }

  ngOnInit(): void {
    this.getTermsAndConditions()
  }

  getTermsAndConditions() {
    let Id = localStorage.getItem('languageId');
    if (Id != null) {
      this.LanguageId = parseInt(Id);
    }
    let language = localStorage.getItem('language');
    if (language != null) {
      this.CountryCode = language;
    }
    this.apiService.getTermsAndConditions(this.LanguageId, this.CountryCode).subscribe((response) => {
      if (response) {       
        this.TermsAndConditionsText=this.sanitizer.bypassSecurityTrustHtml(this.customStyle + response.textContent);
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}


